/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminDisableOrgOptions, AdminDisableOrgResponses } from '../../models/AdminDisableOrg'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Disable an org
 * @summary Disable Org
 * {@link /admin/org/:org_id/disable}
 */
export function adminDisableOrg<ThrowOnError extends boolean = true>(options: Options<AdminDisableOrgOptions, ThrowOnError>): Promise<UnwrappedResult<AdminDisableOrgResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/admin/org/{org_id}/disable', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminDisableOrgResponses, ThrowOnError>>
}
